const {Ajax, AJAX_OPTION: {PREVENT_EXECUTE}} = Mutil;

async function requestTwoFactor(props) {
    const {USER_ID, DUID, AUTH_TYPE} = props;
    const ajaxSpace = new Ajax({packetOption: PREVENT_EXECUTE});
    try {
        await ajaxSpace.executeApi("TWO_FACTOR_C001", {USER_ID, DUID, AUTH_TYPE});
    } catch (e) {
        console.error(`ERROR in requestTwoFactor : ${e}`);
    }
}

async function confirmCertNo(props) {
    const {USER_ID, DUID, AUTH_NO, AUTH_TIME_MM} = props;
    const ajaxSpace = new Ajax({packetOption: PREVENT_EXECUTE});
    try {
        return await ajaxSpace.executeApi("FLOW_AUTH_NO_CHECK_R001", {USER_ID, AUTH_NO, DUID, AUTH_TIME_MM});
    } catch (e) {
        console.error(`ERROR in confirmCertNo : ${e}`);
    }
}

export {requestTwoFactor, confirmCertNo}